module.exports = __webpack_public_path__ + "static/media/consultation_04.db6b7b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/consultation_04.png
// module id = 577
// module chunks = 0